<div class="container myAccount">

    <h1>My Account</h1>

    <!--<ul class="nav nav-pills myAccountTabs" id="myAccountTabs" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">My Info</button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link" id="wallet-tab" data-bs-toggle="tab" data-bs-target="#wallet-tab-pane" type="button" role="tab" aria-controls="wallet-tab-pane" aria-selected="false">My Wallet</button>
        </li>
    </ul>-->

    <div class="tab-content" id="myAccountTabsContent">
        <!-- info -->
        <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
            <div class="accountInfoWrap mt-4">
                <form class="accountInfoWrapForm" [formGroup]="accountInfoForm">
                    <div class="row gx-5">
                        <div class="col-md-6">
                            <div class="mb-4">
                                <label for="firstName" class="form-label">First Name</label>
                                <input formControlName="firstName" type="text" class="form-control" id="firstName" placeholder="First Name">
                                <div *ngIf="firstNameCtrl.invalid && (firstNameCtrl.dirty || firstNameCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-4">
                                <label for="lastName" class="form-label">Last Name</label>
                                <input formControlName="lastName" type="text" class="form-control" id="lastName" placeholder="Last Name">
                                <div *ngIf="lastNameCtrl.invalid && (lastNameCtrl.dirty || lastNameCtrl.touched)">
                                    <i class="fas fa-exclamation-circle"></i> This field is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-4">
                                <label for="yourEmail" class="form-label">Email</label>
                                <input formControlName="emailAddress" type="email" class="form-control" id="yourEmail" placeholder="email@example.com">
                                <div *ngIf="emailAddressCtrl.invalid && (emailAddressCtrl.dirty || emailAddressCtrl.touched)">
                                    <div *ngIf="emailAddressCtrl.errors?.required">
                                        <i class="fas fa-exclamation-circle"></i> This Field is Required
                                    </div>
                                    <div *ngIf="emailAddressCtrl.errors?.email">
                                        <i class="fas fa-exclamation-circle"></i> Must be a valid email.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center mt-4">
                            <button type="button" class="btn btn-secondary m-100 newsSubmitBtn" (click)="saveAccountInfo()">Save Changes</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- saved offers -->
        <!--<div class="tab-pane fade" id="wallet-tab-pane" role="tabpanel" aria-labelledby="wallet-tab" tabindex="0">
            <div class="discountListWrap mt-2 row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-1 row-cols-sm-1 g-5">
                <div *ngFor="let discount of discounts" class="col">
                    <div class="couponCard card h-100">
                        <img *ngIf="discount.logoUrl != ''" src="{{discount.logoUrl}}" class="couponLogo">
                        <div *ngIf="discount.logoUrl == ''" class="noLogo">{{discount.companyName}}</div>
                        <h3>{{discount.value}}</h3>
                        <div class="couponRow">
                            <span class="couponRedeemed">You've Already Claimed This Offer</span>
                        </div>
                        <p>{{discount.validThroughString}}</p>
                        <div class="circle1"></div>
                        <div class="circle2"></div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</div>